import styled from 'styled-components';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.div`
  width: 100%;
  overflow: hidden;

  iframe {
    border: none;
  }

  ${media.mobile`
    position: fixed;
    top: 126px;
    height: calc(100% - 126px);
    z-index: 1;
  `}
  ${media.desktop`
    max-width: 520px;
    height: 600px;
  `}
`;

const StyledIframe = styled.iframe`
  position: relative;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translateX(-50%);
`;

export { StyledContainer, StyledIframe };
